<template>
    <el-dialog
      title="商品无条形码确认"
      :visible.sync="visible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="upc-upload-content">
        <div class="tips">
            条形码利于商品参与平台活动和增加曝光推荐；若您确认商品无条形码，请先上传商品正面图和背面图，上传后无需再填写条形码。
        </div>
        <div class="upc-upload">
            <div class="upload-item">
            <div class="label">商品正面图 <span class="required">*</span></div>
            <ImgUpload
                ref="frontImg"
                :width="120"
                :height="120"
                :file="frontImage"
                :isSingle="true"
                accept=".jpg,.jpeg,.png"
                @upload-success="url => handleUpload('front', url)"
                @del="() => handleUpload('front', '')"
            />
            </div>
            <div class="upload-item">
            <div class="label">商品背面图 <span class="required">*</span></div>
            <ImgUpload
                ref="backImg"
                :width="120"
                :height="120"
                :file="backImage"
                :isSingle="true"
                accept=".jpg,.jpeg,.png"
                @upload-success="url => handleUpload('back', url)"
                @del="() => handleUpload('back', '')"
            />
            </div>

        </div>
      </div>
      <div slot="footer"> 
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary"  @click="visible = false"> 批量采用</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import ImgUpload from "@/components/Uploads/ImgUpload";
  
  export default {
    components: { ImgUpload },
    data() {
      return {
        visible: false,
        frontImage: '',
        backImage: '',
      }
    },
    methods: {
      handleShow() {
        this.visible = true;
        this.frontImage = '';
        this.backImage = '';
      },
      handleUpload(type, url) {
        if(type === 'front') {
          this.frontImage = url;
        } else {
          this.backImage = url;
        }
      },
      handleConfirm() {
        if(!this.frontImage || !this.backImage) {
          this.$message.warning('请上传商品正面图和背面图');
          return;
        }
        this.$emit('success', {
          frontImage: this.frontImage,
          backImage: this.backImage
        });
        this.visible = false;
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .upc-upload-content{
     display: flex;
     flex-direction: column;
  }
  .upc-upload {
    display: flex;
    gap: 20px;
    .upload-item {
      .label {
        margin-bottom: 10px;
        .required {
          color: #F56C6C;
        }
      }
    }
  }
  .tips{
    color: #999;
    margin-bottom: 16px;
  }
  </style>